import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

/**
 * Emotion cache responsible only for RTL CSS transformation.
 *
 * Component/theme overrides live in `src/theme/components` so they are part of
 * the actual application ThemeProvider. Keeping visual rules out of this file
 * avoids "dead" overrides that never reach the mounted MUI theme.
 */
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

export function RTL(props: any) {
    return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>;
}
